import withAPIAction from 'utils/withAPIAction'
import {
  getUnitReportAction,
  getUnitCheckListForQCReq,
  createUnitDefectAction,
  updateUnitDefectAction,
  sendDefectForQCEditAction,
  setUnitDefectAction,
  uploadFileAsyncRequestAction,
  setUnitImageFixAction,
} from './actions'
import {
  GetUnitReportReq,
  GetCheckListForQCReq,
  UnitDefectType,
  EditDefectReq,
  SetUnitDefectReq,
  UpdateImageFileUnitReq,
} from './types'
import { verifyReq } from 'utils/verify'
import { APIPath } from 'services/APIPath'
import { UpdateImageFileCommonReq } from '../zone/types'

export const getUnitReport = (token: string, data: GetUnitReportReq) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<GetUnitReportReq>({
    method: 'POST',
    path: 'GetUnitReportById',
    data,
    token: `Bearer ${token}`,
  })(getUnitReportAction)
}

// get unit checklist for qc
export const getUnitCheckListForQC = (
  token: string,
  data: GetCheckListForQCReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<any>(state => ({
    method: 'POST',
    path: 'GetUnitCheckListForQC',
    data,
    token: `Bearer ${token}`,
  }))(getUnitCheckListForQCReq)
}

export const createUnitDefect = (token: string, data: UnitDefectType) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<UnitDefectType>({
    method: 'POST',
    path: 'CreateUnitDefect	',
    data,
    token: `Bearer ${token}`,
  })(createUnitDefectAction)
}

export const updateUnitDefect = (token: string, data: UnitDefectType) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<UnitDefectType>({
    method: 'POST',
    path: 'UpdateUnitDefect',
    data,
    token: `Bearer ${token}`,
  })(updateUnitDefectAction)
}

export const setUnitDefect = (token: string, data: SetUnitDefectReq) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<SetUnitDefectReq>({
    method: 'POST',
    path: 'SetUnitDefectStatus',
    data,
    token: `Bearer ${token}`,
  })(setUnitDefectAction)
}

export const sendDefectForQCEdit = (token: string, data: EditDefectReq) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<EditDefectReq>({
    method: 'POST',
    path: 'SendDefectForQCEdit			',
    data,
    token: `Bearer ${token}`,
  })(sendDefectForQCEditAction)
}

export const updateImageFileUnit = (
  token: string,
  data: UpdateImageFileUnitReq
) => {
  const isValid = verifyReq(data, token)
  if (isValid !== undefined) return isValid

  return withAPIAction<UpdateImageFileUnitReq>({
    method: 'POST',
    path: 'UpdateImageFileUnit',
    data,
    token: `Bearer ${token}`,
  })(setUnitImageFixAction)
}

export const uploadFileAsyn = (data: any, token: string) => {
  if (token === '') {
    return { type: 'fixImage/no_token' }
  }
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  return withAPIAction<any>({
    method: 'POST',
    path: APIPath.uploadFileActivity,
    data,
    config,
    token: `Bearer ${token}`,
  })(uploadFileAsyncRequestAction)
}
